import { render } from "./VueDataFast.vue?vue&type=template&id=54995c4a"
import script from "./VueDataFast.vue?vue&type=script&lang=js"
export * from "./VueDataFast.vue?vue&type=script&lang=js"

import "./VueDataFast.vue?vue&type=style&index=0&id=54995c4a&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__